export const ENQUEUED = 'ENQUEUED';
export const RETRYING_DOWNLOAD = 'RETRYING_DOWNLOAD';
export const WAITING_FOR_CONCURRENT_DOWNLOAD = 'WAITING_FOR_CONCURRENT_DOWNLOAD';